
import React, { Component } from 'react';

import { DetailProvider, DetailContext } from 'core/DetailProvider';
import { FormContext, FormProvider } from 'core/FormProvider';
import { YellowButton } from 'ui/Button';
import { DriverForm } from './Form';
import Layout from 'components/Dashboard/Layout';


export default class DriverDetail extends Component {

  onLoaded = (item) => {
    document.title = `Водитель ${item.full_name}`;
  };

  render() {
    const { match } = this.props;
    return (
      <DetailProvider
        url={`fleet/driver/${match.params.id}`}
        onLoaded={(item) => this.onLoaded(item)}
      >
        <DetailContext.Consumer>
          {detailContext => {
            let { item } = detailContext;
            return (
              <FormProvider
                url={item.meta.url}
                postSaveMessage={'Водитель обновлён'}
                postSave={(item) => detailContext.updateItem(item)}
                item={item}
              >
                <FormContext.Consumer>
                {formContext => {
                  const { loading } = formContext;
                  return (
                    <Layout>
                      <Layout.Header
                        title={'Редактирование водителя'}
                        backUrl={'/driver'}
                      />

                      <Layout.ContentSimple>
                        <DriverForm />

                        <div className={'mt-30'}>
                          <YellowButton
                            onClick={(e) => formContext.handleSubmit(e)}
                            disabled={loading}
                            size={'large'}
                          >
                            Обновить водителя
                          </YellowButton>
                        </div>
                      </Layout.ContentSimple>
                    </Layout>
                  )
                }}
                </FormContext.Consumer>
              </FormProvider>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
